import { ShapeCardProps } from 'components/ShapeCard/ShapeCard';
import { ImageType } from 'utils/types';

import { ShapeCardsProps } from './ShapeCards';

export const parseShapeCards = (
  section: Queries.ContentfulSection001,
): ShapeCardsProps => {
  const { title, description } = section.metadata ?? {};

  const subsections =
    (section?.subsections as Queries.ContentfulSection001[]) || [];

  const shapeCardsData: ShapeCardProps[] = subsections?.map((subsection) => {
    const { eyebrow } = subsection ?? {};
    const { title, ctas } = subsection.metadata ?? {};
    let desktopImage: ImageType | null = null;
    let mobileImage: ImageType | null = null;

    if (subsection?.images && subsection.images.length > 0) {
      if (subsection.images[0]?.desktopImage?.gatsbyImageData) {
        desktopImage = {
          gatsbyImageData: subsection.images[0]?.desktopImage?.gatsbyImageData,
          description: subsection.images[0]?.desktopImageAltText || '',
        };
      }

      if (subsection.images[0]?.mobileImage?.gatsbyImageData) {
        mobileImage = {
          gatsbyImageData: subsection.images[0]?.mobileImage?.gatsbyImageData,
          description: subsection.images[0]?.mobileImageAltText || '',
        };
      }
    }

    const shapeCard: ShapeCardProps = {
      tagText: eyebrow ?? '',
      headingText: title ?? '',
      bottomText: {
        raw: subsection?.body?.raw || '',
      },
      bottomTextAuthor: subsection?.metadata?.description?.description ?? '',
      desktopImage,
      mobileImage,
      cta: {
        label: ctas?.[0]?.label || '',
        url: ctas?.[0]?.url || '',
      },
      backgroundColor: subsection?.metadata?.theme?.backgroundColor || '',
      textColor: subsection?.metadata?.theme?.textColor || '',
    };

    return shapeCard;
  });

  return {
    eyebrow: section?.eyebrow ?? '',
    title: title ?? '',
    disclaimer: description?.childMarkdownRemark?.html ?? '',
    shapeCardsData: shapeCardsData,
  };
};
